// Redux Action Types
import { SET_SELECTED_SEVEN_DAYS } from '../actions/types';
// Initial State
const initialState = [];

export default function (state = initialState, action) {
  if (action.type === SET_SELECTED_SEVEN_DAYS) return action.payload;
  return state;
}
